import React from 'react';
import {
  submitFormCreate,
  submitFormUpdate,
} from 'actions/ingredients/library';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getFormValues } from 'redux-form';
import styles from './LibraryDetail.css';
import LibraryForm from './LibraryForm';

class LibraryDetail extends React.Component {
  render() {
    return (
      <div className={styles.wrapper}>
        <div className={styles.form}>
          <LibraryForm onSubmit={this._onSubmit} />
        </div>
      </div>
    );
  }

  _onSubmit = values => {
    const {
      dispatch,
      libraries,
      search: { outletIds },
      file,
    } = this.props;
    const formatValues = this._formatOnSave(values);
    // we must delete the 'action' property so it doesn't sent to server.
    const allOutlet = values.action !== 'save';
    delete values.action;
    // if it is create, the api wants 'remote_image_url' to be sent
    if (!values.id) {
      if (values.image && values.image.url) {
        values.remote_image_url = values.image.url;
      } else {
        values.remote_image_url = '';
      }
    }
    if (values.id) {
      dispatch(
        submitFormUpdate(
          values.id,
          { library: formatValues },
          allOutlet,
          libraries,
          file
        )
      );
    } else {
      dispatch(
        submitFormCreate(
          { library: formatValues },
          allOutlet,
          libraries.results,
          outletIds[0],
          libraries,
          file
        )
      );
    }
  };

  _formatOnSave = values => {
    const { units, categories } = this.props;
    const {
      id,
      name,
      image,
      in_stock,
      alert,
      stock_alert,
      cogs,
      track_cogs,
      unit_cost,
      time_synchronized,
      is_recipe,
      description,
      business_id,
      outlet_id,
    } = values;
    const ingredientCategoryId = values.ingredient_category_id;
    const unitId = values.unit_id;
    const idUncategorized = categories.find(
      category => category.name === 'Uncategorized'
    ).id;
    // don't send in stock since it will overwrite the values
    const result = {
      id,
      ingredient_category_id:
        ingredientCategoryId > 0 ? ingredientCategoryId : idUncategorized,
      category_name: categories.find(
        category => category.id === ingredientCategoryId
      ).name,
      name,
      image: image.url === '' || image.url === null ? null : image.url,
      unit_id: unitId,
      remove_image: values.image === '',
      remote_image_url: image,
      unit_name: unitId ? units.find(unit => unit.id === unitId).name : '',
      in_stock,
      alert,
      stock_alert,
      cogs: values.track_cogs ? cogs : null,
      track_cogs,
      unit_cost,
      time_synchronized,
      is_recipe,
      description,
      business_id,
      outlet_id,
    };
    if (!id) {
      // create
      delete result.remote_image_url;
    } else {
      // update
      delete result.in_stock;
    }
    return result;
  };
}

function mapStateToProps(state) {
  const {
    libraries,
    libraryDetail,
    units,
    categories,
  } = state.ingredients.library;
  const { business } = state.moka.user;
  const { file } = state.uploadImage.uploadImage;
  return {
    libraries,
    libraryDetail,
    search: getFormValues('search')(state),
    units,
    categories,
    business_id: business.id,
    file,
  };
}

LibraryDetail.propTypes = {
  Library: PropTypes.object,
  dispatch: PropTypes.func,
};

function mapDispatchToProps(dispatch) {
  return { dispatch };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LibraryDetail);
